var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.68,
    height: 29.15,
    viewBox: "0 0 28.68 29.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.68,15.478c0,8.316-5.695,14.234-14.1,14.234a14.575,14.575,0,1,1,0-29.15,14.016,14.016,0,0,1,9.773,3.814L20.381,8.191C15.192,3.184,5.542,6.945,5.542,15.137a9.13,9.13,0,0,0,9.033,9.2c5.771,0,7.934-4.137,8.275-6.282H14.575V13.045H28.45A12.777,12.777,0,0,1,28.68,15.478Z",
    transform: "translate(0 -0.563)",
    fill: "#ca5040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.acc4ea4cf73a7cbf4538b5d0484dc25e.svg";
export { ForwardRef as ReactComponent };